export const TRANSACTION_STATUSES = [{
  label: 'Open',
  value: 2
}, {
  label: 'Cleared',
  value: 3
}, {
  label: 'Voided',
  value: 4
}];
